import Reveal from "../Reveal";
import { ACTIVITIES } from "../../data/content";

export default function Activities() {
    return (
        <section id="activities" className="section-pad" data-testid="activities-section">
            <div className="container-luxe">
                <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
                    <Reveal>
                        <p className="eyebrow mb-5">Add-on to any package</p>
                        <h2 className="font-serif text-navy text-3xl sm:text-4xl leading-snug">
                            Signature <span className="italic text-gold">activities</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="max-w-xs text-sm font-light leading-relaxed text-stone/85 sm:text-right">
                            Threaded into your itinerary — never bolted on, always chosen with you.
                        </p>
                    </Reveal>
                </div>

                <Reveal delay={0.15}>
                    <ul className="flex flex-wrap gap-3 sm:gap-4" data-testid="activities-pill-list">
                        {ACTIVITIES.map((a) => (
                            <li key={a}>
                                <span
                                    data-testid="activity-pill"
                                    className="inline-flex items-center gap-2.5 rounded-full border border-gold/50 px-5 py-2.5 text-sm font-light text-navy transition-all duration-300 hover:bg-gold/15 hover:-translate-y-0.5 cursor-default"
                                >
                                    <span className="h-1 w-1 rounded-full bg-gold" aria-hidden="true" />
                                    {a}
                                </span>
                            </li>
                        ))}
                    </ul>
                </Reveal>
            </div>
        </section>
    );
}
